/*
 * Copyright 2014-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Subject } from 'rxjs';

export default {
  data() {
    return {
      destroy$: new Subject<void>(),
    };
  },
  created() {
    this.subscribe();
  },
  beforeUnmount() {
    // Emit to signal all subscriptions to complete
    this.destroy$.next();
    this.destroy$.complete();
    this.unsubscribe();
  },
  methods: {
    async subscribe() {
      if (!this.subscription) {
        this.subscription = await this.createSubscription();
      }
    },
    unsubscribe() {
      if (this.subscription && !this.subscription.closed) {
        try {
          this.subscription.unsubscribe();
        } finally {
          this.subscription = null;
        }
      }
    },
  },
};
